<template>
    <div>
        <div class="listingPageTitle">
            <h1>Tag Maintenance</h1>
            <ItemModal ref="modal" :itemName="'Tag'"
                            :formRows="newFormRows"
                            :saveItemFunction="save"
                            :refreshItemsFunction="loadRecords"></ItemModal>
        
        </div>
        <div class="searchContainer">
            <div class="formRow"><span class="inputTitle">Search Name/Description: </span><input type="text" v-model="searchText" /></div>
            <div class="formRow" v-if="tagTypes"><span class="inputTitle">Search Tag Type: </span>
                <select v-model="tagType">
                    <option v-for="(tagType, index) in tagTypes" :key="index" :name="tagType.displayName">{{tagType.displayName}}</option>
                </select>
            </div>
            <div class="formRow"><span class="inputTitle">Active Only: </span><input type="checkbox" v-model="onlyShowActive" /></div>
        </div>
        <hr />
        <ListingTable v-if="tags" :columns="columns" :filterCriteria="filterCriteria" :actions="actionMappings" 
            :key="componentKey" :intitializationParameters="{sortBy: 'description'}" />
    </div>
</template>

<script>
import {data} from '../../shared/data';
import ItemModal from '@/components/ItemModal.vue';
import ListingTable from '@/components/shared/ListingTable.vue';

export default {
    name: 'TagListing',
    components: {ItemModal, ListingTable},
    data: function() {
        return {
            tags: [],
            searchText: "",
            tagType: "",
            onlyShowActive: true,
            tagTypes: null,
            componentKey: 0,
            columns: [ 
                {
                    headerDisplayName: "ID",
                    width: "10%",
                    fieldName: "id"
                },
                {
                    headerDisplayName: "Short Name",
                    width: "20%",
                    fieldName: "name"
                },
                {
                    headerDisplayName: "Description",
                    width: "50%",
                    fieldName: "description"
                },
                {
                    headerDisplayName: "Tag Type",
                    width: "10%",
                    fieldName: "tagTypeDescription"
                },
                {
                    width: "10%",
                    columnType: "buttons",
                    showDeleteFieldName: "isActive",
                    showUndeleteFieldName: "!isActive",
                    showListingFieldName: null,
                    showEditFieldName: "true"
                }
            ],
            newFormRows: [
                {
                    name: 'Short Name',
                    propertyName: 'name',
                    required: true,
                    element: 'input'
                },
                {
                    name: 'Description',
                    propertyName: 'description',
                    required: true,
                    element: 'textarea'
                },
                {
                    name: 'Tag Type',
                    propertyName: 'tagType',
                    required: true,
                    element: 'select'
                }
            ],
            actionMappings: {
                onLoadData: this.loadRecords, 
                onUndelete: this.reactivateRecord,
                onDelete: this.deleteRecord, 
                onEdit: this.editRecord
            },
        }
    },
    computed: {
        filterCriteria () {
            var criteria = [];
            if(this.searchText != "") 
                criteria.push( {
                    dataType: "MultiString",
                    fieldNames: ["description", "name"],
                    value: this.searchText
                });

            if(this.tagType != "")
                criteria.push( {
                    dataType: "String",
                    fieldName: "tagTypeDescription",
                    value: this.tagType
                });
            
            if(this.onlyShowActive) {
                criteria.push( {
                    dataType: "Boolean",
                    fieldName: "isActive",
                    value: true
                });

            }
            return criteria;
        }
    },
    methods: {
        loadRecords: async function() {
            var types = await data.getEnumList("TagTypes");
            if(types.length > 2)
            {
                  this.tagTypes = types;
                  this.newFormRows[2].selectOptions = types;

            } 
            else {
                this.newFormRows.splice(2, 1);
            }

            const dat = await data.getTags("", "", false);
            return dat;
        },
        save: async function(saveObject) {
            return this.save_common(saveObject, true);
        },
        save_common: async function(saveObject, displaySuccess) {
            if(!saveObject.id) {
                if(!this.tagTypes)
                    saveObject["tagType"] = "AccordionDetail";
            }

            var retObject = this.processSaveResult(await data.saveTag(saveObject));

            if(retObject.success) {
                if(displaySuccess)
                    this.componentKey++;

                if(retObject.id)
                    saveObject.id = retObject.id;

                return retObject;
                
            }
            else
                return retObject;
        },
        editRecord: async function(values) {
            var tag = await data.getTag(values.id);  
            this.$refs.modal.editRecord(tag.id, tag);  
        },
        deleteRecord: async function(values) {
            if(confirm('Are you sure you want to delete this tag?')) {
                var status = this.processDeactivateResult(await data.deleteTag(values.id));
                if(status.success) 
                    values.isActive = false;                     
            }                        
        },
        reactivateRecord: async function(values) {
            values.isActive = true;
            var status = await this.save_common(values, false);
            if(!status.success)
                values.isActive = false;
        },
    }
}
</script>
